type Callback = (id: string) => void;

let interopAccountId: string | null = null;
let listeners: Callback[] = [];

export function setInteropAccountId(id: string) {
  interopAccountId = id;
  for (const cb of listeners) {
    cb(id);
  }
  listeners = [];
}

export function getInteropAccountId(): string | null {
  return interopAccountId;
}

export function onInteropAccountIdSet(cb: Callback): void {
  if (interopAccountId !== null) {
    cb(interopAccountId);
  } else {
    listeners.push(cb);
  }
}
